import Button from "@mui/material/Button";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import TooltipWithClickAway from "../../components/terminalPicker/TooltipWithClickAway";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import AppState from "../../AppState";
import Loader from "../../components/loader/loader";
import { PopoutNotification } from "../../AppState/popoutNotification";
import NOTIFICATION_TYPE from "../../AppState/NotificationType";
import {
  compareObjects,
  handleKeyDown,
  handleNumberMaxLength,
  handlePaste,
} from "../../helpers";
import { IDamage, IDamageEntryDetail } from "../../models/prException";
import { isFormValueChanged } from "../../AppState/isFormValueChanged";
import UploadDocument from "../../components/uploadDocument/uploadDocument";
import DamageFollowUp from "./damageFollowUp";
import { GetPartialRefusalAPI } from "../../API/getPartialRefusal";
import { INIT_PR_FORM_VALUE, PREntrySchema } from "../../schema/prException";
import { UpdatePREntryAPI } from "../../API/updatePREntry";
import DamageInvestigation from "./DamageInvestigation";
import DeliveredDamagesFollowUp from "./DeliveredDamagesFollowUp";
import { usePackageMaster } from "../../@hooks/usePackageMaster";
import { CommodityField } from "../../components/shared/form";
import PackageField from "../../components/shared/form/packageField";
import PageHeaderWithBack from "../../components/PageHeaderWithBack";
import { useDateTimeFormatter } from "../../@hooks/useDateTimeFormatter";
import {
  FORM_STYLES,
  EOsdType,
  EUploadKey,
  EPRStatus
 } from "../../constants";

const DamageEntry = () => {
  const dispatch = useDispatch();
  const { osdNumber, osdType: rawOsdType } = useParams();
  const osdType = rawOsdType?.toUpperCase();
  const isDD = osdType === EOsdType.dd;

  const headingTitle = {
    [EOsdType.pr]: "Partial Refusal ",
    [EOsdType.rd]: "Refused Damage ",
    [EOsdType.rf]: "Arbitrary Refusal ",
    [EOsdType.dd]: "Delivered Damages ",
  };

 

  const [isSubmitted, setIsSubmitted] = React.useState<boolean>(false);
  const [isEditMode, setIsEditMode] = React.useState<boolean>(false);

  const [formFieldsDisabled, setFormFieldsDisabled] = React.useState<boolean>(
    Boolean(osdNumber)
  );
  const [osdDetails, setOsdDetails] = React.useState<IDamageEntryDetail>();
  const [updatedDateTime, setUpdatedDateTime] = React.useState<string>("");
   const formatShortageDateTime = useDateTimeFormatter(setUpdatedDateTime);
  const [isCompleteAndImage, setIsCompleteAndImage] =
    React.useState<boolean>(false);

  const [investigationStatus, setInvestigationStatus] =
    React.useState<number>();
  const isfollowup = investigationStatus === EPRStatus.followupInProgress;
  const isCleared = investigationStatus === EPRStatus.needsCleared;
  const [editFormValueChanged, setEditFormValueChanged] =
    React.useState<boolean>(false);

  const { loadPackageOptions } = usePackageMaster();
  const packageCodeOptions = useSelector(
    (state: AppState) => state.packageOptionMasterData
  );
  const [pageLoading, setPageLoading] = useState<boolean>(false);
  // get master from API for commodity code and package code
  const [expanded, setExpanded] = React.useState<string[]>(["panel1"]); // handle expand page using "expanded" variable
  const handleInvestigationSubmit = () => {
    setIsEditMode(true);
    setExpanded((prev) =>
      prev.includes("panel3") ? prev : [...prev, "panel3"]
    );
  };

  const handleInvestigationComplate = () => {
    setExpanded((prev) =>
      prev.includes("panel2") ? prev : [...prev, "panel2"]
    );
  };

  // set Initial value of Partial Refusal entry form
  const [isEditFormValuePatched, setIsEditFormValuePatched] =
    React.useState<string>("");
  const initValue: any = INIT_PR_FORM_VALUE;

  const [initialFormValue, setInitialFormValue] =
    React.useState<any>(initValue);

  // Initialize Partial refusal entry form using formik and pass validation schema and initial values
  // handle all form event and submit form using formik

  const {
    values,
    errors,
    handleChange,
    handleBlur,
    touched,
    handleSubmit,
    setFieldValue,
    resetForm,
    isSubmitting,
  } = useFormik({
    validationSchema: PREntrySchema,
    validateOnChange: false,
    initialValues: initValue,

    // Submit the form if all form fields are validated
    onSubmit: (values) => {
      if (!editFormValueChanged && osdNumber) {
        return;
      }
      setPageLoading(true);
      const reqInput = {
        ...values,
        weight: Number.parseInt(values.weight),
        pieces: Number.parseInt(values.pieces),
        commodity: values.commodity?.trim(),
        description: values.description?.trim(),
        itemCartonModelSerialNumber: values.itemCartonModelSerialNumber?.trim(),
      };

      const handleResponse = (response: IDamage) => {
        setPageLoading(false);
        setIsSubmitted(true);
        setExpanded(["panel1", "panel2"]);
        setFormFieldsDisabled(true);
        viewPartialRefusalEntry(response.osdNumber ?? osdNumber);
        dispatch(
          PopoutNotification(
            NOTIFICATION_TYPE.SUCCESS,
            `OS&D # ${osdNumber} has been updated successfully`,
            Date.now().toString()
          )
        );
      };

      const handleError = (err: any) => {
        setPageLoading(false);
        dispatch(
          PopoutNotification(
            NOTIFICATION_TYPE.ERROR,
            err || `OS&D # ${osdNumber} updating failed`,
            Date.now().toString()
          )
        );
      };
      UpdatePREntryAPI(reqInput, osdNumber ?? "")
        .then(handleResponse)
        .catch(handleError);
    },
  });

  const getErrorMessage = (error: string, touched: boolean) => {
    if (!error || !touched) return null;
    return <span className="form-error">{error}</span>;
  };

  const hasError = (field: string) => {
    return Boolean(errors[field] && touched[field]);
  };

  // get Commodity and package code option master
  const getMasters = (ParamString: string) => {
    if (ParamString === "packageCode") {
      loadPackageOptions();
    }
  };

  const isPanelRestricted = (panel: string, isExpanded: boolean) => {
    const isRestrictedByEntryState =
      ["panel2", "panel3", "panel4"].includes(panel) &&
      isExpanded &&
      !isSubmitted &&
      !osdNumber;

    const isRestrictedByDisposition =
      panel === "panel3" &&
      isExpanded &&
      !isDD &&
      !(isfollowup || isCleared);

    return isRestrictedByEntryState || isRestrictedByDisposition;
  };

  const getNextExpandedPanels = (panel: string, isExpanded: boolean) => {
    if (isExpanded) {
      return Array.from(new Set([...expanded, panel]));
    }

    return expanded.filter((item) => item !== panel);
  };

  // Handle accordion expand
  const handleAccordionChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      if (isPanelRestricted(panel, isExpanded)) {
        return;
      }

      setFormFieldsDisabled(true);
      reset();

      setExpanded(getNextExpandedPanels(panel, isExpanded));
    };

  const enableEditing = () => {
    setFormFieldsDisabled(false);
  };

  // set form value on exception type changed
  const reset = () => {
    resetForm();
    patchEditFormValues(initialFormValue);
  };


  const patchEditFormValues = (partialRefusal: any) => {
    const trimOrDefault = (value: any) =>
      typeof value === "string" ? value.trim() || "" : value;

    // Set form field values
    Object.keys(INIT_PR_FORM_VALUE).forEach((field) => {
      setFieldValue(field, trimOrDefault(partialRefusal[field]));
    });

    // Indicate that form values have been patched
    setIsEditFormValuePatched(Date.now().toString());
  };

  const viewPartialRefusalEntry = (osdId: number | string = "") => {
    const exceptionNum = osdNumber ?? osdId;
    if (exceptionNum) {
      // get AS entry and set form fields
      setPageLoading(true);
      GetPartialRefusalAPI(osdNumber ?? osdId ?? "")
        .then((partialRefusal: IDamage) => {
          formatShortageDateTime(partialRefusal);

          if (partialRefusal?.weight === 0) {
            partialRefusal["weight"] = undefined;
          }
          if (partialRefusal?.pieces === 0) {
            partialRefusal["pieces"] = undefined;
          }
          setOsdDetails(partialRefusal);
          setInvestigationStatus(partialRefusal?.investigationStatusNumber);
          patchEditFormValues(partialRefusal);
          setPageLoading(false);
        })
        .catch((err: any) => {
          console.error(err);
          setPageLoading(false);
        });
    }
  };

  const renderInputField = (
    label: string,
    valueKey: keyof IDamageEntryDetail,
    placeholder: string,
    maxLength: number = 5
  ) => {
    return (
      <Grid item md={3} xs={12}>
        <FormControl fullWidth size="small">
          <InputLabel
            htmlFor={valueKey}
            style={FORM_STYLES.LABEL}
            shrink={true}
            id="piecesLabel"
          >
            {label} <sup>*</sup>
          </InputLabel>
          <TextField
            autoComplete="off"
            id={valueKey}
            data-testid={valueKey}
            placeholder={placeholder}
            type="number"
            onPaste={handlePaste}
            variant="outlined"
            onChange={handleChange}
            error={hasError(valueKey)}
            disabled={formFieldsDisabled}
            onBlur={handleBlur}
            name={valueKey}
            value={values[valueKey] === 0 ? "" : values[valueKey]}
            onKeyDown={handleKeyDown}
            onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleNumberMaxLength(e, maxLength);
            }}
          />
        </FormControl>
        {getErrorMessage(
          errors[valueKey] as string,
          touched[valueKey] as boolean
        )}
      </Grid>
    );
  };

  const renderDisabledInputField = (
    label: string,
    filedKey: keyof IDamageEntryDetail,
    required: string = "",
    md: number = 3
  ) => {
    return (
      <Grid item md={md} xs={12}>
        <FormControl fullWidth size="small">
          <InputLabel style={FORM_STYLES.LABEL} shrink={true} id="lastTrailerLabel">
            {label} <sup>{required ?? " "}</sup>
          </InputLabel>
          <TextField
            id={filedKey}
            value={
              filedKey === "lastManifest" && osdDetails?.[filedKey] === 0
                ? ""
                : osdDetails?.[filedKey] ?? ""
            }
            data-testid={filedKey}
            name={filedKey}
            disabled
            variant="outlined"
          />
        </FormControl>
      </Grid>
    );
  };

  const helperText = (field: keyof IDamageEntryDetail) => {
    return touched[field] && !!errors[field] && !values[field]
      ? (errors[field] as string)
      : "";
  };

  useEffect(() => {
    if (osdNumber && isEditFormValuePatched) {
      setInitialFormValue(values);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditFormValuePatched]);

  useEffect(() => {
    setEditFormValueChanged(!compareObjects(values, initialFormValue));
    dispatch(isFormValueChanged(!compareObjects(values, initialFormValue)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, initialFormValue]);

  useEffect(() => {
    dispatch(isFormValueChanged(false));
    if (osdNumber) {
      viewPartialRefusalEntry();
    }

    if (!packageCodeOptions?.length) {
      getMasters("packageCode");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isSubmitting) return;
    if (Object.keys(errors)?.length > 0) {
      document.getElementsByName(Object.keys(errors)[0])[0].focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmitting]);

  return (
    <div className="bg-layout overage-entry">
      {/* header */}
      <PageHeaderWithBack
        osdNumber={osdNumber}
        updatedDateTime={updatedDateTime}
        headingTitle={headingTitle[osdType as keyof typeof headingTitle]}
      />

      {/* body */}
      <div className="content-area">
        <Accordion
          className="accordion"
          expanded={expanded.includes("panel1")}
          onChange={handleAccordionChange("panel1")}
        >
          <AccordionSummary
            className="header"
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography className={"queue-check queue-check-gc"}>1</Typography>
            <Typography className="accordion-header">
              {headingTitle[osdType as keyof typeof headingTitle]} Exception
            </Typography>
          </AccordionSummary>
          <form action="" onSubmit={handleSubmit}>
            <AccordionDetails className="accordion-container">
              <div id="overageEntry">
                <Grid container spacing={2} className="filter-margin">
                  {renderDisabledInputField("Type", "type", "*")}
                  {renderDisabledInputField(
                    "Reporting Terminal",
                    "reporting",
                    "*"
                  )}
                </Grid>
                <div>
                  <Grid container spacing={2} className="filter-margin">
                    {renderDisabledInputField("PRO#", "proNumber", "*")}
                    {renderDisabledInputField("Origin Terminal", "origin")}
                    {renderDisabledInputField(
                      "Destination Terminal",
                      "destination"
                    )}
                  </Grid>
                  <Grid container spacing={2} className="filter-margin">
                    {renderDisabledInputField("Last Trailer Number", "trailer")}
                    {renderDisabledInputField(
                      "Last Manifest Number",
                      "lastManifest"
                    )}
                  </Grid>

                  <Grid container spacing={2} className="filter-margin">
                    {renderDisabledInputField(
                      "Shipper Account #",
                      "shipperAccount"
                    )}
                    {renderDisabledInputField("Shipper Name", "shipper")}
                    {renderDisabledInputField(
                      "Shipper Address",
                      "shipperAddress",
                      "",
                      6
                    )}
                  </Grid>

                  <Grid container spacing={2} className="filter-margin">
                    {renderDisabledInputField("Shipper Zip", "shipperZip")}
                    {renderDisabledInputField("Shipper City", "shipperCity")}
                    {renderDisabledInputField("Shipper State", "shipperState")}
                  </Grid>

                  <Grid container spacing={2} className="filter-margin">
                    {renderDisabledInputField(
                      "Consignee Account #",
                      "consigneeAccount"
                    )}
                    {renderDisabledInputField("Consignee Name", "consignee")}
                    {renderDisabledInputField(
                      "Consignee Address",
                      "consigneeAddress",
                      "",
                      6
                    )}
                  </Grid>

                  <Grid container spacing={2} className="filter-margin">
                    {renderDisabledInputField("Consignee Zip", "consigneeZip")}
                    {renderDisabledInputField(
                      "Consignee City",
                      "consigneeCity"
                    )}
                    {renderDisabledInputField(
                      "Consignee State",
                      "consigneeState"
                    )}
                  </Grid>
                </div>

                <Grid container spacing={2} className="filter-margin">
                  <CommodityField
                    id="commodity"
                    label="Commodity"
                    key={values.commodity}
                    disabled={formFieldsDisabled}
                    value={values.commodity}
                    onChange={(_, value) =>
                      setFieldValue("commodity", value?.code)
                    }
                    placeholder="Enter commodity"
                    required
                    onBlur={handleBlur("commodity")}
                    error={touched.commodity && !!errors.commodity}
                    helperText={helperText("commodity")}
                  />

                  <PackageField
                    formFieldsDisabled={formFieldsDisabled}
                    value={values.package ?? ""}
                    handleChange={(event) => {
                      setFieldValue("package", event.target.value);
                    }}
                    handleBlur={handleBlur("package")}
                    error={helperText("package")}
                    hasError={(field, condition) =>
                      !!touched[field.toString()] && condition
                    }
                  />

                  {renderInputField("Total Pieces", "pieces", "Enter Pieces")}

                  {renderInputField("Weight", "weight", "Enter Weight", 7)}
                </Grid>

                <Grid container spacing={2} className="filter-margin">
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth size="small">
                      <InputLabel
                        style={FORM_STYLES.LABEL}
                        shrink={true}
                        id="consigneeAddressLabel"
                      >
                        Does the shipment have (Item#, Carton#, Model#, Serial#){" "}
                        <sup>*</sup>
                      </InputLabel>
                      <TextField
                        autoComplete="off"
                        inputProps={{ maxLength: 56 }}
                        id="outlined-basic"
                        placeholder="Enter Item#, Carton#, Model#, Serial# with comma separated"
                        variant="outlined"
                        onChange={handleChange}
                        error={hasError("itemCartonModelSerialNumber")}
                        data-testid="itemCartonModelSerialNumber"
                        disabled={formFieldsDisabled}
                        onBlur={handleBlur}
                        name="itemCartonModelSerialNumber"
                        value={values.itemCartonModelSerialNumber ?? ""}
                      />
                    </FormControl>
                    {getErrorMessage(
                      errors.itemCartonModelSerialNumber as string,
                      touched.itemCartonModelSerialNumber as boolean
                    )}
                  </Grid>
                  <Grid item md={8} xs={12}>
                    <FormControl className="radio-group value-range">
                      <FormLabel id="valueRangeLabel">
                        Value Range <sup>*</sup>
                      </FormLabel>

                      <Grid container spacing={2}>
                        <Grid
                          item
                          md={12}
                          xs={12}
                          className="float-div form-content-start"
                        >
                          <FormGroup className="shift-left">
                            <RadioGroup
                              row
                              aria-labelledby="valueRange"
                              name="valueRange"
                              value={osdDetails?.valueRange}
                              data-testid="valueRange"
                            >
                              <FormControlLabel
                                value="1"
                                disabled
                                control={<Radio />}
                                label="$0 - $250.00"
                                name="valueRange"
                                checked={osdDetails?.valueRange === "1"}
                              />
                              <FormControlLabel
                                value="2"
                                disabled
                                control={<Radio />}
                                label="$250.00 - $1,000.00"
                                name="valueRange"
                                checked={osdDetails?.valueRange === "2"}
                              />
                              <FormControlLabel
                                disabled
                                value="3"
                                control={<Radio />}
                                label="Greater than $1,000.00"
                                name="valueRange"
                                checked={osdDetails?.valueRange === "3"}
                              />
                              <TooltipWithClickAway
                                tooltipText="If value needs to be edited e-mail catkinson@saia.com"
                                tooltipKey="tooltip1"
                              />
                            </RadioGroup>
                          </FormGroup>

                          {osdDetails?.valueRange === "3" && (
                            <FormGroup className="no-wrap">
                              <FormGroup className="form-row shift-left">
                                <TextField
                                  autoComplete="off"
                                  className="justify-content disabled"
                                  value="$"
                                  variant="outlined"
                                  disabled
                                />
                                <TextField
                                  autoComplete="off"
                                  type="number"
                                  onPaste={handlePaste}
                                  className="justify-content"
                                  placeholder="Enter Amount"
                                  variant="outlined"
                                  disabled
                                  name="value1k"
                                  value={osdDetails?.value1k}
                                  data-testid="value1k"
                                />
                              </FormGroup>
                            </FormGroup>
                          )}
                        </Grid>
                      </Grid>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={2} className="filter-margin">
                  {renderDisabledInputField(
                    "Number of Shrink Wrapped Pallets",
                    "shrinkWrappedPalletCount",
                    "",
                    4
                  )}

                  <Grid item md={8} xs={12}>
                    <FormControl className="radio-group value-range">
                      <FormLabel id="wasOriginalShrinkwrapIntactLabel">
                        Was the Original Shrinkwrap Intact? <sup>&nbsp;</sup>
                      </FormLabel>

                      <Grid container spacing={2}>
                        <Grid
                          item
                          md={12}
                          xs={12}
                          className="float-div form-content-start"
                        >
                          <FormGroup className="shift-left">
                            <RadioGroup
                              row
                              aria-labelledby="wasOriginalShrinkwrapIntact"
                              name="wasOriginalShrinkwrapIntact"
                              value={osdDetails?.wasOriginalShrinkwrapIntact}
                              data-testid="wasOriginalShrinkwrapIntact"
                            >
                              <FormControlLabel
                                value="Y"
                                disabled
                                control={<Radio />}
                                label="Yes"
                                name="wasOriginalShrinkwrapIntact"
                                checked={
                                  osdDetails?.wasOriginalShrinkwrapIntact ===
                                  "Y"
                                }
                              />
                              <FormControlLabel
                                value="N"
                                disabled
                                control={<Radio />}
                                label="No"
                                name="wasOriginalShrinkwrapIntact"
                                checked={
                                  osdDetails?.wasOriginalShrinkwrapIntact ===
                                  "N"
                                }
                              />
                            </RadioGroup>
                          </FormGroup>
                        </Grid>
                      </Grid>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid container spacing={2} className="filter-margin">
                  {renderDisabledInputField(
                    `Complete detailed description of freight and extent of damage if applicable`,
                    "description",
                    "*",
                    12
                  )}
                </Grid>
              </div>
              <div className="btn-group-submit">
                {Boolean(osdNumber) && !formFieldsDisabled && (
                  <>
                    <Button
                      type="button"
                      variant="contained"
                      className="clear-btn mr-0 ml"
                      onClick={() => reset()}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      data-testid="submit-button"
                      variant="contained"
                      className={
                        editFormValueChanged
                          ? "entry mr-0 ml"
                          : "disable-btn disable entry mr-0 ml"
                      }
                    >
                      Submit
                    </Button>
                  </>
                )}

                {Boolean(osdNumber) && formFieldsDisabled && !isCleared && (
                  <Button
                    data-testid="edit-button"
                    variant="contained"
                    className="assign mr-0 ml"
                    onClick={enableEditing}
                  >
                    Edit
                  </Button>
                )}
              </div>
            </AccordionDetails>
          </form>
        </Accordion>

        {!isDD && (
          <Accordion
            className="accordion"
            expanded={expanded.includes("panel2")}
            onChange={handleAccordionChange("panel2")}
          >
            <AccordionSummary
              className="header"
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
            >
              <Typography
                className={
                  isCleared || isfollowup
                    ? "queue-check queue-check-gc"
                    : "queue-check"
                }
              >
                2
              </Typography>
              <Typography className="accordion-header">
                {headingTitle[osdType as keyof typeof headingTitle]}{" "}
                Investigation &nbsp;&nbsp;&nbsp;
              </Typography>
            </AccordionSummary>

            <DamageInvestigation
              setInvestigationStatus={setInvestigationStatus}
              osdDetails={osdDetails}
              osdNumber={+(osdNumber ?? "")}
              isComplete={isCompleteAndImage}
              osdType={osdType}
              onInvestigationSubmit={handleInvestigationSubmit}
              onInvestigationComplate={handleInvestigationComplate}
            />
          </Accordion>
        )}

        <Accordion
          className="accordion"
          expanded={expanded.includes("panel3")}
          onChange={handleAccordionChange("panel3")}
        >
          <AccordionSummary
            className="header"
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
          >
            <Typography
              className={
                isCleared ? "queue-check queue-check-gc" : "queue-check"
              }
            >
              {isDD ? 2 : 3}
            </Typography>
            <Typography className="accordion-header">
              {headingTitle[osdType as keyof typeof headingTitle]} Follow Up
              &nbsp;&nbsp;&nbsp;
            </Typography>
          </AccordionSummary>

          {isDD ? (
            <DeliveredDamagesFollowUp
              setInvestigationStatus={setInvestigationStatus}
              osdDetails={osdDetails}
              osdNumber={+(osdNumber ?? "")}
            />
          ) : (
            <DamageFollowUp
              setInvestigationStatus={setInvestigationStatus}
              osdDetails={osdDetails}
              osdNumber={+(osdNumber ?? "")}
              osdType={osdType}
              isEditMode={isEditMode}
              setIsCompleteAndImage={setIsCompleteAndImage}
            />
          )}
        </Accordion>

        <Accordion
          className="accordion"
          expanded={expanded.includes("panel4")}
          onChange={handleAccordionChange("panel4")}
        >
          <AccordionSummary
            className="header"
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
          >
            <Typography className="queue-check">{isDD ? 3 : 4}</Typography>
            <Typography className="accordion-header">
              Upload Documents
            </Typography>
          </AccordionSummary>
          <UploadDocument
            key={expanded.toString() || "upload-document"}
            osdNumber={Number.parseInt(osdNumber!)}
            uploadKey={EUploadKey.pro}
          />
        </Accordion>
      </div>
      <Loader pageLoader={pageLoading}></Loader>
    </div>
  );
};

export default DamageEntry;
